// extracted by mini-css-extract-plugin
export default {"tab":"style_tab__5xy0z","tabContainer":"style_tabContainer__z0+YY"};